// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__D-EP9","field":"styles_field__3vsHe","fieldCol":"styles_fieldCol__VGSBh","diffCol":"styles_diffCol__3bvDX","diff":"styles_diff__LpLFN"};